import React from 'react'
import _ from 'lodash'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IconArrowLeft from '../images/icon_arrow_left.svg'
import IconArrowRight from '../images/icon_arrow_right.svg'
import isFallBackToWhiteColor from '../helpers/isFallBackToWhiteColor'
import * as StyledComponent from '../styles'

const ArrowLeft = (props) => <img alt='prev-arrow' src={IconArrowLeft} {..._.pick(props, ['onClick','className'])}/>
const ArrowRight = (props) => <img alt='next-arrow' src={IconArrowRight} {..._.pick(props, ['onClick','className'])}/>

const ColorPicker = (props, context) => {
  const { is_color_switch_placeholder, colors, selectColor, selected_color } = props

  // chunk the colors into seperate groups by the no of palette per row, 2 rows per page
  const colors_arrays_by_no_of_palette_per_row = _.chunk(colors, 14)

  // css class for css animation when color is ready to be shown
  const ready = is_color_switch_placeholder ? '' : 'ready'

  // mapping color_slides by the chunk of colors palettes arrays
  const color_slides = _.map(colors_arrays_by_no_of_palette_per_row, (colors_slide, color_slide_index) => {
    return <div key={`$color-slide-${color_slide_index}`} className='color-palettes-container'>
      {
        _.map(colors_slide, (color, color_index) => {
          const selected = selected_color.id === color.id ? 'selected': ''
          // test if hex value is equal to white or not a hex value
          const white = isFallBackToWhiteColor(color.hex_value)
            ? 'white'
            : ''

          return <div
            key={`${color.name}-${color.id}`}
            className={`color-palette-outer ${selected} ${white}`}
          >
            <div
              className={`color-palette ${ready} ${selected} ${white}`}
              style={{ backgroundColor: color.hex_value }}
              onClick={selectColor.bind(this, color.id)}
            >
              {
                color.swatch &&
                <img src={color.swatch.versions.mobile_thumb_square} alt={color.name} />
              }
            </div>
          </div>
        })
      }
    </div>
  })

  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    // nextArrow: <img alt='next-arrow' src={IconArrowRight} />,
    // prevArrow: <img alt='pre-arrow' src={IconArrowLeft} />
    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />
  }

  return <StyledComponent.ColorPicker>
    {
      colors.length > props.page_size
        ? <Slider {...settings}>
          { color_slides }
          </Slider>
        : <div className='color-palettes-container'>
          {
            _.map(props.colors, color => {
              const selected = selected_color.id === color.id ? 'selected': ''
              // test if hex value is equal to white or not a hex value
              const white = isFallBackToWhiteColor(color.hex_value)
                ? 'white'
                : ''

              return <div
                key={`${color.name}-${color.id}`}
                className={`color-palette-outer ${selected} ${white}`}
              >
                <div
                  className={`color-palette ${ready} ${selected} ${white}`}
                  style={{ backgroundColor: color.hex_value }}
                  onClick={selectColor.bind(this, color.id)}
                >
                  {
                    color.swatch
                    && <img src={color.swatch.versions.mobile_thumb_square} alt={color.name} />
                  }
                </div>
              </div>
            })
          }
        </div>
    }
  </StyledComponent.ColorPicker>
}

ColorPicker.defaultProps = {
  colors: [],
  selected_color: {},
  selectColor: () => {},
  page_size: 14
}

export default ColorPicker



// WEBPACK FOOTER //
// ./src/components/ColorPicker.js